import { BaseBlock } from './blocks';

export interface IPairingBlock {
  id: string;
  type: 'pairing';
  content: {
    title: string;
    subtitle: string;
    options: any[];
    matches: any[];
    placement?: string;
  };
}

export type PairingBlock = BaseBlock & {
  content: {
    title: string;
    subtitle: string;
    placement?: string;
    display: PairingGroupDisplay.Columns;
    optionsName?: string;
    matchesName: string;
    options: PairingItemData[];
    matches: PairingItemData[];
  };
};

export interface PairingGroupData {
  display: PairingGroupDisplay;
  optionsName?: string;
  matchesName?: string;
  options: Array<PairingItemData>;
  matches: Array<PairingItemData>;
}

export interface PairingItemData {
  id: string;
  format: PairingItemFormat;
  title?: string;
  image?: string;
  color?: string;
  matches?: Array<String>;
  active?: boolean;
}

export enum PairingItemFormat {
  Text = 'text',
  Image = 'image',
  TextImage = 'text-image',
  ImageText = 'image-text',
}

export enum PairingGroupDisplay {
  Random = 'random',
  Columns = 'columns',
}
